import { createContext, useContext } from "react";
import { UseFormReturn } from "react-hook-form";
import { PropertyFieldsFormData } from "../schemas/property-fields-schema";
import { PropertySectionViewModel } from "../types/property-section.view-model";

export type PropertyFieldsContextType = {
  isEditing: boolean;
  setIsEditing: (isEditing: boolean) => void;
  sections: PropertySectionViewModel[];
  getValueOfField: (dataKey: string) => any;
  form: UseFormReturn<PropertyFieldsFormData>;
  handleSubmit: (e: React.FormEvent) => void;
  isSubmitting: boolean;
};

export const PropertyDetailsContext = createContext<PropertyFieldsContextType | undefined>(
  undefined
);

export const usePropertyFields = () => {
  const context = useContext(PropertyDetailsContext);

  if (!context) {
    throw new Error("usePropertyFields must be used within a PropertyDetailsProvider");
  }

  return context;
};
